// @flow

import React from 'react';
import _ from 'lodash';
import { CSSTransition } from 'react-transition-group';
import CoordinateIcon from './NewCoordinateIcon';
import Button from './NewButton';
import type { Coordinate } from './types';

const TR_SPEED = 200;
const ICON_AMOUNT = 5;

type Props = {
  picture: Image,
  assetPath: string,
  coordinates: Array<Coordinate>,
};

type State = {
  active: boolean,
  classNames: string,
  coordinates: Array<Coordinate>,
};

export default class CoordinateLibrary extends React.PureComponent<Props, State> {
  nextImg: string;
  prevImg: string;
  pages: number;
  step: number;
  constructor(props: Props): void {
    super(props);
    this.state = {
      coordinates: this.props.coordinates,
      active: true,
      classNames: 'ps__coor-item-down',
      step: 0,
    };
    this.pages = Math.ceil(this.props.coordinates.length / ICON_AMOUNT);
    this.nextImg = `${this.props.assetPath}assets/games/picture_search/chevron-right.png`;
    this.prevImg = `${this.props.assetPath}assets/games/picture_search/chevron-left.png`;
  }

  componentDidUpdate(prevProps: Props): void {
    if (this.props !== prevProps) {
      this.pages = Math.ceil(this.props.coordinates.length / ICON_AMOUNT);
    }
  }

  clipArray = (num: number): number => _.clamp(num, 0, this.state.coordinates.length);

  mod = (a: number, n: number): number => a - (n * Math.floor(a / n));

  nextPage = () => {
    this.setState((state) => {
      const oldStep = state.step;
      if (oldStep >= this.pages - 1) {
        return { step: 0 };
      }
      return { step: oldStep + 1 };
    });
  };

  prevPage = () => {
    this.setState((state) => {
      const oldStep = state.step;
      if (oldStep <= 0) {
        return { step: this.pages - 1 };
      }
      return { step: oldStep - 1 };
    });
  };

  renderCoordIcons = (page: number) =>
    this.props.coordinates
      .slice(this.clipArray(page * ICON_AMOUNT), this.clipArray((page * ICON_AMOUNT) + ICON_AMOUNT))
      .map((item, index) => {
        const pageIndex = (page * ICON_AMOUNT) + index;
        return (
          <CoordinateIcon
            picture={this.props.picture}
            iconid={`icon-${pageIndex}`}
            key={pageIndex}
            coordinate={item}
          />);
      });

  scrollEvent = (e: SyntheticWheelEvent<>) => {
    e.preventDefault();
    if (e.deltaY >= 1) {
      this.nextPage();
    } else if (e.deltaY <= -1) {
      this.prevPage();
    }
  }

  render(): React$Element<any> {
    return (
      <React.Fragment>
        <div className="xl:mt-4 xl:flex-0 max-w-full flex flex-row bg-white rounded-lg px-2 shadow z-50 items-center" onWheel={this.scrollEvent}>
          {this.props.coordinates.length > ICON_AMOUNT && <Button img={this.prevImg} buttonClass="-ml-2" click={this.prevPage} showArrow={this.props.coordinates.length > 5}/>}
          <CSSTransition
            in={this.state.active}
            classNames={this.state.classNames}
            timeout={TR_SPEED}
          >
            <div className={`${this.state.classNames}-enter-done flex flex-row space-x-2`}>
              {this.renderCoordIcons(this.state.step)}
            </div>
          </CSSTransition>
          {this.props.coordinates.length > ICON_AMOUNT && <Button img={this.nextImg} buttonClass="-mr-2" click={this.nextPage} showArrow={this.props.coordinates.length > 5} />}
        </div>
      </React.Fragment>
    );
  }
}
